import React, { ButtonHTMLAttributes } from 'react';
import { Button as HeadlessButton } from '@headlessui/react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  isLoading?: boolean;
  fullWidth?: boolean;
}

export function Button({ 
  children, 
  variant = 'primary', 
  isLoading = false, 
  fullWidth = false,
  className = '', 
  disabled,
  ...props 
}: ButtonProps) {
  // Base styles including the Headless UI data-[active] scale effect
  const baseStyles = "relative flex justify-center items-center px-4 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200 data-[active]:scale-[0.98] data-[disabled]:opacity-70 data-[disabled]:pointer-events-none focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-brand-500";
  
  const variants = {
    primary: "bg-brand-900 text-white data-[hover]:bg-brand-950 shadow-sm data-[hover]:shadow-md",
    secondary: "bg-brand-50 text-brand-900 data-[hover]:bg-brand-100",
    outline: "bg-white text-slate-700 border border-slate-300 data-[hover]:bg-slate-50 data-[hover]:border-slate-400 shadow-sm"
  };

  return (
    <HeadlessButton 
      className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </HeadlessButton>
  );
}